// extracted by mini-css-extract-plugin
export default {"waiting":"OpeningDrop_waiting__9X_6I","disclaimer":"OpeningDrop_disclaimer__XgzBq","description":"OpeningDrop_description__QQYAu"};